import React from 'react'
import { Link } from 'react-router-dom'

export default function NotFoundPage() {
    return (
        <div className="p-8 text-center">
            <h1 className="text-2xl font-bold">페이지를 찾을 수 없습니다 (404)</h1>
            <p className="text-slate-600 mt-2">주소를 확인하시거나 대시보드로 이동하세요.</p>
            <div className="mt-4">
                <Link className="rounded bg-brand-navy text-white px-4 py-2" to="/">대시보드로</Link>
            </div>
        </div>
    )
}


